<template>
  <div>
    <div v-if="!value.length" class="ed-empty">Nenhuma empresa no grupo da empresa dona da campanha.</div>

    <div v-for="(company, index) in value" :key="company.companyId" class="ed-panel ed-company">
      <div class="ed-company__head">
        <v-checkbox
          :input-value="company.selected"
          color="primary"
          hide-details
          class="ma-0 pa-0 shrink"
          @change="update(index, { selected: !!$event })"
        ></v-checkbox>
        <div>
          <div class="ed-company__name">{{ company.name }}</div>
          <div class="ed-help">{{ company.cnpj }} · {{ company.selected ? "participa da campanha" : "não participa" }}</div>
        </div>
      </div>

      <div v-if="company.selected" class="ed-company__body">
        <span class="ed-label">Meios de pagamento</span>
        <div class="ed-check-grid">
          <v-checkbox
            v-for="method in paymentMethods"
            :key="method.id"
            :input-value="company.paymentMethodIds.indexOf(method.id) >= 0"
            :label="method.name"
            color="primary"
            hide-details
            @change="toggleMethod(index, method.id, $event)"
          ></v-checkbox>
        </div>

        <div v-if="company.paymentMethodIds.indexOf(PAYROLL) >= 0" class="ed-payroll">
          <div class="ed-subtitle">Débito em folha</div>
          <v-radio-group :value="company.payrollWithInstallments" row hide-details class="mt-0" @change="update(index, { payrollWithInstallments: $event })">
            <v-radio label="Com parcelamento ou recorrência" :value="true" color="primary"></v-radio>
            <v-radio label="Sem parcelamento" :value="false" color="primary"></v-radio>
          </v-radio-group>
          <div class="ed-payroll__add">
            <v-select v-model="draft[company.companyId + '_n']" :items="availableHowMany(company)" label="Parcelas" class="ed-payroll__n"></v-select>
            <v-text-field v-model="draft[company.companyId + '_d']" label="Descrição exibida ao doador"></v-text-field>
            <v-btn small depressed color="primary" class="ed-payroll__btn" @click="addParcelament(index)">Adicionar</v-btn>
          </div>
          <div v-for="option in company.payrollParcelaments" :key="option.howMany" class="ed-payroll__option">
            <strong class="ed-payroll__count">{{ option.howMany }}x</strong>
            <span class="ed-payroll__desc">{{ option.description }}</span>
            <v-switch :input-value="option.active" color="primary" class="shrink ma-0 pa-0" hide-details @change="setOption(index, option.howMany, { active: !!$event })"></v-switch>
            <v-btn small flat icon title="Remover" @click="removeParcelament(index, option.howMany)"><i class="fal fa-times"></i></v-btn>
          </div>
        </div>

        <EditorRecurrenceList
          class="mt-4"
          :periods="recurrencePeriods"
          :value="company.recurrencePeriods"
          @input="update(index, { recurrencePeriods: $event })"
        />
      </div>
    </div>
  </div>
</template>
<script>
// Público interno (CampaignCompanyPaymentMethod / CampaignCompanyDonationRecurrencePeriod / Parcelament).
import EditorRecurrenceList from "./EditorRecurrenceList.vue";

const PAYROLL = 1;
const HOW_MANY = Object.freeze(Array.from({ length: 13 }, (unused, n) => ({ value: n, text: n === 0 ? "0x Sem parcelamento" : `${n}x` })));

export default {
  name: "EditorCompanyPayments",
  components: { EditorRecurrenceList },
  props: {
    value: { type: Array, default: () => [] },
    paymentMethods: { type: Array, default: () => [] },
    recurrencePeriods: { type: Array, default: () => [] },
  },
  data() {
    return { PAYROLL, draft: {} };
  },
  methods: {
    update(index, changes) {
      const companies = this.value.slice();
      companies[index] = Object.assign({}, companies[index], changes);
      this.$emit("input", companies);
    },
    toggleMethod(index, methodId, checked) {
      const current = this.value[index].paymentMethodIds.filter((id) => id !== methodId);
      this.update(index, { paymentMethodIds: checked ? current.concat([methodId]) : current });
    },
    availableHowMany(company) {
      const used = company.payrollParcelaments.map((option) => option.howMany);
      return HOW_MANY.filter((item) => used.indexOf(item.value) < 0);
    },
    addParcelament(index) {
      const company = this.value[index];
      const howMany = this.draft[company.companyId + "_n"];
      const description = (this.draft[company.companyId + "_d"] || "").trim();
      if (howMany === undefined || howMany === null || !description) {
        this.$store.commit("SET_SNACKBAR_MESSAGE", "Informe as parcelas e a descrição");
        return;
      }
      const options = company.payrollParcelaments
        .concat([{ id: 0, howMany, description, active: true, default: false }])
        .sort((a, b) => a.howMany - b.howMany);
      this.$set(this.draft, company.companyId + "_n", null);
      this.$set(this.draft, company.companyId + "_d", "");
      this.update(index, { payrollParcelaments: options });
    },
    setOption(index, howMany, changes) {
      this.update(index, {
        payrollParcelaments: this.value[index].payrollParcelaments.map((option) =>
          option.howMany === howMany ? Object.assign({}, option, changes) : option
        ),
      });
    },
    removeParcelament(index, howMany) {
      if (!window.confirm("Remover esta opção de parcelamento?")) return;
      this.update(index, { payrollParcelaments: this.value[index].payrollParcelaments.filter((option) => option.howMany !== howMany) });
    },
  },
};
</script>

<style scoped>
.ed-company__head {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ed-company__name {
  font-weight: 600;
  font-size: 14px;
}
.ed-company__body {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--ced-border, #e3e5ec);
}
.ed-payroll {
  margin-top: 12px;
}
.ed-payroll__add {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
}
.ed-payroll__btn {
  text-transform: none;
  border-radius: 999px;
}
.ed-payroll__option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid var(--ced-border, #e3e5ec);
}
.ed-payroll__count {
  width: 36px;
}
.ed-payroll__desc {
  flex: 1;
}
@media (max-width: 960px) {
  .ed-payroll__add {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
